import React, { FC } from 'react';
import SvgIcon from './SvgIcon';

const AtIcon: FC = () => {
    return (
        <SvgIcon viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.5 10C8.88071 10 10 8.88071 10 7.5C10 6.11929 8.88071 5 7.5 5C6.11929 5 5 6.11929 5 7.5C5 8.88071 6.11929 10 7.5 10Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 7.49942V8.43692C10 8.85132 10.1646 9.24875 10.4576 9.54177C10.7507 9.8348 11.1481 9.99942 11.5625 9.99942C11.9769 9.99942 12.3743 9.8348 12.6674 9.54177C12.9604 9.24875 13.125 8.85132 13.125 8.43692V7.49942C13.1266 6.29073 12.7387 5.11369 12.019 4.14266C11.2993 3.17163 10.2859 2.45826 9.12899 2.10823C7.9721 1.7582 6.73323 1.79012 5.5959 2.19927C4.45857 2.60842 3.48328 3.37303 2.8145 4.37984C2.14573 5.38665 1.81904 6.5821 1.88284 7.7891C1.94664 8.9961 2.39753 10.1505 3.16872 11.0811C3.93991 12.0118 4.99037 12.6694 6.16449 12.9563C7.33862 13.2433 8.57395 13.1445 9.6875 12.6744"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default AtIcon;
